import React, { memo, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Form, Card, Input, Switch, Button } from 'antd';
import request from '@utils/request';
import { validateFields, awaitWrapper, pad, removeAccent } from '@utils/helper';
import UserInfo from '@common/UserInfo';
import BankQR from '@common/BankQR';
import './style.less';

class PayloadDetail extends PureComponent {
  constructor() {
    super();
    this.state = {
      loading: false,
      showQR: false,
    }
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    const [err, values] = await validateFields(this.props.form);
    if (!err) {
      this.setState({ loading: true });
      const { item, year, month } = this.props;
      const payloadData = { userId: item.userId, year, month };
      Object.keys(values).forEach(k => {
        let v = values[k];
        if (v && k !== 'note' && k !== 'isDone' && typeof v === 'string') {
          v = v.replace(/\./g, '');
        }
        payloadData[k] = v;
      })

      let err;
      if (item.id) {
        [err] = await awaitWrapper(request.put(`v1/payloads/${item.id}`, payloadData));
      } else {
        [err] = await awaitWrapper(request.post(`v1/payloads/`, payloadData));
      }
      if (!err) {
        this.props.onChange();
      }
      this.setState({ loading: false });
    }
  }
  handleBankComplete = async () => {
    this.setState({ loading: true });
    const { item } = this.props;
    const payloadData = {
      isDone: true,
    }
    const [err] = await awaitWrapper(request.put(`v1/payloads/${item.id}`, payloadData));
    if (!err) {
      this.props.onChange();
    }
    this.setState({ loading: false });
  }
  handleChangeDay = () => {
    const {user, form} = this.props;
    const {getFieldValue, setFieldsValue} = form;
    const day = parseFloat(getFieldValue('day') || '0');
    if(day > 0 && (user.basicSalary > 0 || user.allowance > 0)){
      const basicSalary = Math.floor(user.basicSalary/26 * day);
      const allowance = Math.floor(user.allowance/26 * day);
      setFieldsValue({basicSalary, allowance});
    }

  }
  handleChangeHour = () => {
    const {user, form} = this.props;
    const {getFieldValue, setFieldsValue} = form;
    const hour= parseInt(getFieldValue('hour') || '0');
    if(hour > 0 && user.overtimeFeePerHour > 0){
      const overtimeSalary = user.overtimeFeePerHour * hour;
      setFieldsValue({overtimeSalary});
    }

  }
  getName = name => {
    const names = removeAccent(name).split(' ');
    let result = names[names.length - 1];
    for (let i = 0; i < names.length - 1; i++) {
      result += names[i][0].toUpperCase();
    }
    return result;
  }
  render() {
    const { item, form, year, month } = this.props;
    const { getFieldDecorator } = form;
    const { loading } = this.state;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    let total = 0;
    let bankQRProps = {
      visible: false
    }
    if (item.id) {
      const { basicSalary, allowance, preSalary, overtimeSalary, bankName, bankAccount, name } = item;
      total = basicSalary + allowance - preSalary + overtimeSalary;
      if (!item.isDone) {
        bankQRProps = {
          visible: this.state.showQR,
          bankName, bankAccount, name,
          reason: `OTina%20${year}${pad(month)}`,
          amount: total,
        }
      }
    }

    return (
      <>
        <Card
          hoverable
          title={<>
            <UserInfo userId={item.userId} mode="name" />{` `}{total > 0 ? total.toLocaleString() : ''}
          </>}
          extra={<Button disabled={!total} icon="qrcode" onClick={() => this.setState({ showQR: true })} />}
          disabled={loading || item.isDone}
          actions={[
            <Button disabled={loading || item.isDone} loading={loading} icon="save" onClick={this.handleSubmit}>{item.id ? 'Update' : 'Create'}</Button>,
          ]}
          style={{ marginTop: 16 }}
        >
          <Form {...formItemLayout} className="payloadForm" disabled={item.isDone}>
            <Form.Item label="Ngày công">
              {getFieldDecorator('day', { initialValue: item.day })(
                <Input
                  placeholder="Ngày công"
                  onBlur={this.handleChangeDay}
                />
              )}
            </Form.Item>
            <Form.Item label="Giờ tăng ca">
              {getFieldDecorator('hour', { initialValue: item.hour })(
                <Input
                  placeholder="Giờ tăng ca"
                  onBlur={this.handleChangeHour}
                />
              )}
            </Form.Item>
            <Form.Item label="Lương căn bản">
              {getFieldDecorator('basicSalary', { initialValue: item.basicSalary })(
                <Input
                  placeholder="Lương căn bản"
                />
              )}
            </Form.Item>
            <Form.Item label="Phụ cấp">
              {getFieldDecorator('allowance', { initialValue: item.allowance })(
                <Input
                  placeholder="Phụ cấp"
                />
              )}
            </Form.Item>
            <Form.Item label="Tăng ca">
              {getFieldDecorator('overtimeSalary', { initialValue: item.overtimeSalary })(
                <Input
                  placeholder="Tăng ca"
                />
              )}
            </Form.Item>
            <Form.Item label="Tạm ứng">
              {getFieldDecorator('preSalary', { initialValue: item.preSalary })(
                <Input
                  placeholder="Tạm ứng"
                />
              )}
            </Form.Item>
            <Form.Item label="Ghi chú">
              {getFieldDecorator('note', { initialValue: item.note })(
                <Input.TextArea
                  placeholder="Ghi chú"
                />
              )}
            </Form.Item>
            <Form.Item label="Đã thanh toán">
              {getFieldDecorator('isDone', { initialValue: item.isDone, valuePropName: 'checked' })(
                <Switch />
              )}
            </Form.Item>
          </Form>
        </Card>
        <BankQR {...bankQRProps} onOk={this.handleBankComplete} onCancel={() => this.setState({ showQR: false })} />
      </>
    );
  }
}

PayloadDetail.propTypes = {
  year: PropTypes.number,
  month: PropTypes.number,
  item: PropTypes.object,
  user: PropTypes.object,
};

PayloadDetail.defaultProps = {
  year: 0,
  month: 0,
  item: {},
  user: {},
};


const mapDispatchToProps = dispatch => ({
});

const withConnect = connect(null, mapDispatchToProps);

const PayloadDetailWrapper = Form.create()(PayloadDetail)

export default compose(withConnect, memo)(PayloadDetailWrapper);